// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"515":"e19f7163593b91ae","697":"4cc45c8f9e01de58"}[chunkId] + ".js";
};